import type { FooterProps } from './types';
import { clsx } from 'clsx';
import { NewsletterRegistration } from '../newsletter';
import './styles.css';
import { FooterCart, FooterDefault, FooterSlim } from './variants';
import { LayoutTypes, PAGE_TYPES } from 'data-layer/constants';
import { ArticlesContent } from '../articleContent';

export function Footer(props: FooterProps) {
  const { content, device, layoutConfig, locale, newsletter, pageType } = props;

  // Calculate current year server-side to avoid dynamic rendering issues
  const currentYear = props.currentYear ?? new Date().getFullYear();

  // Cart page has its own special footer variant
  const isCartPage = pageType === PAGE_TYPES.CartPage;

  // Determine footer variant from layoutConfig (defaults to 'default')
  const footerType = layoutConfig?.footerType || LayoutTypes.Default;
  const isSlimFooter = footerType === LayoutTypes.Slim || footerType === LayoutTypes.SeaSlim;
  const isDefaultFooter = footerType === LayoutTypes.Default;
  const isCartFooter = footerType === LayoutTypes.Cart || isCartPage;

  // Pass currentYear to all footer variants
  const footerPropsWithYear = { ...props, currentYear };

  return (
    <footer className={clsx('footer', `footer__${footerType}`)}>
      {content.length > 0 && (
        <ArticlesContent
          articles={content}
          defaultMobileLayout={true}
          device={device}
          isFooterContent={true}
          locale={locale}
        />
      )}
      <div className="footer__inner">
        {newsletter?.isVisible && isDefaultFooter && <NewsletterRegistration {...newsletter} />}
        {isDefaultFooter && <FooterDefault {...footerPropsWithYear} />}
        {isSlimFooter && <FooterSlim {...footerPropsWithYear} />}
        {isCartFooter && <FooterCart {...footerPropsWithYear} />}
      </div>
    </footer>
  );
}
